import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const generatedReportsFetchApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${
    API_ENDPOINT.GeneratedReport.generatedReportApi +
    '?isB2B=true&page=' +
    page +
    '&pageSize=' +
    data.pageSize +
    '&city=' +
    (data?.city ? data?.city : '')
  }`;

  if (data?.type) {
    url = url + '&tripType=' + data?.type;
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
